// Physical enclosure is shared by live occupancy and place presentation.
// These are authored type values, never guesses from names or prose.
const enclosedTypes = new Set(['building', 'barracks', 'chapel', 'cottage', 'guildhall', 'hall',
  'house', 'inn', 'interior space', 'room', 'floor', 'shop', 'shrine', 'stable', 'structure',
  'tavern', 'temple', 'fortification', 'tower', 'warehouse', 'workshop', 'underground area']);
const parentIds = place => [...(place?.parentIds || []), ...(place?.composedOfParentIds || []),
  ...(place?.composedOfParents || []).map(parent => parent.idEntity)].filter(Boolean);
const isEnclosedPlace = place => {
  const shapes = place?.shapes?.length ? place.shapes : place?.shape ? [place.shape] : [];
  // Perimeter wall paths block sight at their solid sections. Their hierarchy
  // does not turn gates, streets or the whole courtyard into indoor rooms.
  if (shapes.length && shapes.every(shape => ['path', '7005'].includes(String(shape.shapeType).toLowerCase()))) return false;
  return [place?.placeType, place?.buildingType, place?.zoneType]
    .some(value => enclosedTypes.has(String(value || '').trim().toLowerCase()));
};
const enclosedPlaceIds = places => {
  const enclosed = new Set(places.filter(isEnclosedPlace).map(place => place.idEntity));
  // A nested space stays enclosed even when its own type is generic.
  let changed = true;
  while (changed) {
    changed = false;
    for (const place of places) if (!enclosed.has(place.idEntity) && parentIds(place).some(id => enclosed.has(id))) {
      enclosed.add(place.idEntity);
      changed = true;
    }
  }
  return enclosed;
};
module.exports = { isEnclosedPlace, enclosedPlaceIds, parentIds };
